import {
  Card,
  CardContainer,
  Description,
  Heading,
  Title,
  UseCase,
  UseCases,
} from './UseCaseCard.styles';

export type UseCaseType = {
  title: string;
  description?: string;
};

export type UseCaseCardProps = {
  heading?: string;
  useCases: UseCaseType[];
};

export const UseCaseCard = ({ heading, useCases }: UseCaseCardProps) => {
  return (
    <CardContainer>
      <Card>
        {heading && (
          <Heading role="heading" aria-level={2}>
            {heading}
          </Heading>
        )}
        <UseCases>
          {useCases.map((item) => (
            <UseCase key={item.title}>
              <Title>{item.title}</Title>
              {item.description && <Description>{item.description}</Description>}
            </UseCase>
          ))}
        </UseCases>
      </Card>
    </CardContainer>
  );
};
